import React from 'react';
import { Link } from 'react-router-dom';
import { IoCaretBackOutline } from 'react-icons/io5';
import './Navbar.css'
const ProjectNavbar = ({ bgColor, textColor }) => {
    return (
        <div style={{ backgroundColor: `${bgColor}`, color: `${textColor}`, position: "fixed", width: "100%", top: "0", zIndex: "100" }} >
            <div className="navbar__width">
                <div >
                    <div className=" navbar__container">
                        <h3 style={{ paddingTop: "1rem" }} className="logo">
                            <Link to="/">
                                <IoCaretBackOutline className="backward__button" />
                            </Link>
                        </h3>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProjectNavbar;